import ServerUrl from './ServerUrl';

let Environment;

if (ServerUrl.indexOf('qa') > -1) {
  Environment = 'QA';
} else if (ServerUrl.indexOf('localhost') > -1 || ServerUrl.indexOf('amc:') > -1) {
  Environment = 'DEVELOPMENT';
} else {
  Environment = 'PRODUCTION';
}

export default Environment;



// WEBPACK FOOTER //
// ./src/views/Framework/Constants/Environment.tsx